import { render } from "./CreateSbus.vue?vue&type=template&id=3d50dc7a"
import script from "./CreateSbus.vue?vue&type=script&lang=js"
export * from "./CreateSbus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__